import React from 'react';
import {
  CheckWrapper,
  CheckMark,
  CheckMarkStem,
  CheckMarkKick,
} from './styles';

const CheckMarkComponent = ({ fillColor, ...props }) => (
  <CheckMark {...props}>
    <CheckMarkStem $fillColor={fillColor} />
    <CheckMarkKick $fillColor={fillColor} />
  </CheckMark>
);

const CheckButton = ({ checked, onClick, ...props }) => (
  <CheckWrapper
    onClick={onClick}
    $backgroundColor={props.backgroundColor}
    $borderRadius={props.borderRadius}
    $width={props.width}
    $borderColor={props.borderColor}
    $checked={checked}
  >
    {checked && <CheckMarkComponent fillColor={props.fillColor} />}
  </CheckWrapper>
);

export default CheckButton;
